module.exports = __webpack_public_path__ + "img/self-love.9cc14a41.jpg";